import CalendarMonth from "../utils/CalendarMonth";
import CalendarI18n from "../utils/CalendarI18n";
import {DceJsx, DceJsxRenderer} from "../../../../../dce-jsx"

export default class MonthRenderer extends DceJsxRenderer {

    private _month: CalendarMonth;
    private name: string;
    private mondayStart: boolean;
    private now: number;

    private _onDayClick: (month: CalendarMonth, day:number, elem: HTMLElement) => void;

    constructor(month: CalendarMonth, now: number, mondayStart: boolean) {
        super();
        this.now = now;
        this._month = month;
        this.name = CalendarI18n.getInstance().monthWithYear(month);
        this.mondayStart = mondayStart;
    }

    get month(): CalendarMonth {
        return this._month;
    }

    set onDayClick(value: (month: CalendarMonth, day: number, elem: HTMLElement) => void) {
        this._onDayClick = value;
    }

    private dayClick(e:any, day: number){
        let event = e as MouseEvent;
        (e.target as HTMLElement).classList.add('selected');

        console.log("DAY CLICKED", day);

        if(this._onDayClick){
            this._onDayClick(this.month, day, e.target as HTMLElement);
        }
    }


    render(): JSX.Element {

        let fday = this._month.firstWeekDay();

        console.log("FIRST DAY", fday, this._month.monthLength());

        //7dni * 6 tygodni
        let days: DayData[] = [];

        if (this.mondayStart) {
            fday = fday - 1;
            if (fday < 0) {
                fday = 6;
            }
        }

        for (let i = 0; i < fday; i++) {
            days.push(null);
        }

        let d = 1;

        let todaynum = this._month.dayNumberInMonth(this.now)

        for (let i = fday; i < this._month.monthLength() + fday; i++) {

            let clazz = "";
            if(d == todaynum){
                clazz += "dce-fullcalendar-today";
            }

            days.push({
                number: d,
                className: clazz,
                label: d + ""
            });
            d++;
        }

        let blen = days.length;

        for (let i = blen; i < (6 * 7); i++) {
            days.push(null);
        }
        console.log("days", days);

        let rows = [];
        for (let r = 0; r < 6; r++) {
            rows.push(
                days.slice(7 * r, 7 * (r + 1))
            );
        }

        console.log("ROES", rows);

        return (
            <tbody className={"dce-fullcalendar-month"}>
            <tr>
                <td colSpan={7} className="dce-calendar-month-name">{this.name}</td>
            </tr>

            {
                rows.map(row => {
                    return (
                        <tr>
                            {
                                row.map(d => {
                                    if(d == null){
                                        return (
                                            <td>&nbsp;</td>
                                        )
                                    }
                                    return (
                                        <td><span onClick={(e) => this.dayClick(e, d.number)} className={"dce-fullcalendar-day " + d.className}>{d.label}</span></td>
                                    )
                                })
                            }
                        </tr>
                    )
                })
            }

            </tbody>
        )
    }

}

interface DayData {
    label: string;
    number: number;
    className: string
}